export const colorsChartTheme4 = {
    goals: {
        medium: { light: "rgba(6, 50, 84, 1)", dark: "rgba(244, 244, 244, 1)" }
    },
    cyan: {
        dark: {
            light: "rgba(4, 65, 119, 1)",
            dark: "rgba(19, 86, 145, 1)"
        },
        medium: {
            light: "rgba(6, 108, 199, 1)",
            dark: "rgba(29, 132, 224, 1)"
        },
        light: {
            light: "rgba(136, 198, 251, 1)",
            dark: "rgba(163, 213, 255, 1)"
        },
        darker: {
            light: "rgba(2, 43, 79, 1)",
            dark: "rgba(14, 62, 105, 1)"
        },
        lighter: {
            light: "rgba(136, 198, 251, 1)",
            dark: "rgba(163, 213, 255, 1)"
        },
        disabled: {
            light: "rgba(136, 198, 251, 1)",
            dark: "rgba(163, 213, 255, 1)"
        }
    },
    purple: {
        medium: {
            light: "rgba(191, 136, 48, 1)",
            dark: "rgba(217, 162, 76, 1)"
        },
        darker: {
            light: "rgba(98, 70, 24, 1)",
            dark: "rgba(122, 92, 42, 1)"
        },
        dark: {
            light: "rgba(147, 105, 37, 1)",
            dark: "rgba(173, 130, 61, 1)"
        },
        light: {
            light: "rgba(214, 167, 92, 1)",
            dark: "rgba(240, 196, 127, 1)"
        },
        lighter: {
            light: "rgba(222, 185, 124, 1)",
            dark: "rgba(247, 216, 163, 1)"
        }
    },
    yellow: {
        light: {
            light: "rgba(157, 167, 17, 1)",
            dark: "rgba(181, 191, 38, 1)"
        },
        medium: {
            light: "rgba(115, 122, 12, 1)",
            dark: "rgba(140, 148, 30, 1)"
        },
        dark: {
            light: "rgba(115, 122, 12, 1)",
            dark: "rgba(140, 148, 30, 1)"
        },
        darker: {
            light: "rgba(115, 122, 12, 1)",
            dark: "rgba(140, 148, 30, 1)"
        }
    },
    violet: {
        lighter: {
            light: "rgba(212, 155, 166, 1)",
            dark: "rgba(237, 197, 205, 1)"
        },
        "lighter-weight": {
            light: "rgba(224, 184, 192, 1)",
            dark: "rgba(250, 230, 234, 1)"
        },
        light: {
            light: "rgba(200, 126, 140, 1)",
            dark: "rgba(224, 164, 175, 1)"
        },
        "light-weight": {
            light: "rgba(207, 140, 154, 1)",
            dark: "rgba(232, 181, 192, 1)"
        },

        medium: {
            light: "rgba(207, 116, 132, 1)",
            dark: "rgba(182, 84, 102, 1)"
        },
        dark: {
            light: "rgba(168, 89, 104, 1)",
            dark: "rgba(143, 61, 76, 1)"
        },
        darker: {
            light: "rgba(125, 66, 77, 1)",
            dark: "rgba(100, 43, 53, 1)"
        }
    },
    magenta: {
        medium: {
            light: "rgba(158, 131, 141, 1)",
            dark: "rgba(184, 171, 175, 1)"
        },
        light: {
            light: "rgba(186, 155, 166, 1)",
            dark: "rgba(186, 155, 166, 1)"
        },
        lighter: {
            light: "rgba(201, 171, 182, 1)",
            dark: "rgba(201, 171, 182, 1)"
        }
    },
    gray: {
        medium: {
            light: "rgba(206, 215, 222, 1)",
            dark: "rgba(218, 227, 235, 1)"
        }
    },
    basic: {
        medium: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        },
        dark: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    },
    black: {
        petroleum: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    }
};
